import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-100 border-t border-slate-200 pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="https://i.postimg.cc/QNvq7rTm/Whats-App-Image-2026-03-12-at-18-54-11.jpg" 
                alt="Logo APM 8 de Maio" 
                className="w-12 h-12 object-contain"
                referrerPolicy="no-referrer"
              />
              <div className="flex flex-col">
                <span className="text-lg font-bold tracking-tight text-primary leading-none uppercase">Associação De Pais E Mestres</span>
                <span className="text-[10px] font-medium text-secondary tracking-wider uppercase">8 de Maio</span>
              </div>
            </Link>
            <div className="space-y-2">
              <p className="text-slate-500 text-sm leading-relaxed max-w-xs">
                CNPJ: 15.578.875/0001-42
              </p>
              <p className="text-slate-500 text-sm leading-relaxed max-w-xs">
                Promovendo a integração entre escola, família e comunidade.
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-neutral-900 mb-6 uppercase text-xs tracking-widest">Links Rápidos</h4>
            <ul className="space-y-4">
              <li><Link to="/" className="text-neutral-500 hover:text-neutral-900 transition-colors text-sm">Início</Link></li>
              <li><Link to="/atividades" className="text-neutral-500 hover:text-neutral-900 transition-colors text-sm">Atividades</Link></li>
              <li><Link to="/sobre-nos" className="text-neutral-500 hover:text-neutral-900 transition-colors text-sm">Sobre Nós</Link></li>
              <li><Link to="/contato" className="text-neutral-500 hover:text-neutral-900 transition-colors text-sm">Contato</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-bold text-neutral-900 mb-6 uppercase text-xs tracking-widest">Legal</h4>
            <ul className="space-y-4">
              <li><Link to="/politica-de-privacidade" className="text-neutral-500 hover:text-neutral-900 transition-colors text-sm">Política de Privacidade</Link></li>
              <li><Link to="/termos-de-uso" className="text-neutral-500 hover:text-neutral-900 transition-colors text-sm">Termos de Uso</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-neutral-900 mb-6 uppercase text-xs tracking-widest">Localização</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-neutral-500">
                <MapPin size={16} className="text-neutral-400 mt-1" />
                Iguatemi - MS
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-neutral-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-xs text-center md:text-left">
            © {currentYear} A. Pais e Mestres - Escola Estadual 8 de Maio. Todos os direitos reservados.
          </p>
          <div className="flex items-center space-x-6">
             <Link to="/admin" className="text-neutral-400 hover:text-neutral-900 text-xs transition-colors">Acesso Restrito</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
